/**
 * Items are matched by normalised name within a category (SPEC §6). Must stay identical to
 * the backend's normalisation (transactions.item_key).
 */
export function normaliseItem(name: string): string {
  return name.trim().replace(/\s+/g, ' ').toLowerCase();
}

/** SPEC §7: item name 2 to 60 characters. */
export function isValidItemName(name: string): boolean {
  const n = name.trim().length;
  return n >= 2 && n <= 60;
}
